var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "SAS badge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "sas-bg",
    width: 24,
    height: 24,
    rx: 6,
    fill: "var(--sas-bg, #3d84ff)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "sas-text",
    x: 12,
    y: 12,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Inter, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    fill: "var(--sas-text, #ffffff)"
  }, "\n    SAS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSas);
export default __webpack_public_path__ + "static/media/sas.efa7b059de70d6e7a6228ca66ae26ab1.svg";
export { ForwardRef as ReactComponent };